import { API_SERVICE } from "@/services/api.service";

export default {
    namespaced: true,
    state: {},
    mutations: {},
    getters: {},
    actions: {
        async updatePreferences(_, payload) {
            return new Promise((resolve) => {
                const params = {
                    body: {
                        clientName: payload.clientName,
                        PersonOID: payload.PersonOID,
                        Preferences: payload.Preferences
                    }
                };
               
                API_SERVICE.patch("peoplePortalRestAPI", "/accounts/prospects/preferences", params)
                    .then((res) => {
                        resolve({
                            snackbarSuccess: res.status === "200",
                            showSnackbar: true
                        });
                    })
                    .catch(() => {
                        resolve({
                            snackbarSuccess: false,
                            showSnackbar: true
                        });
                    });
            });
        },

        async updatePropertyAlerts(_, payload) {
            return new Promise((resolve) => {
                const params = {
                    body: {
                        clientName: payload.clientName,
                        prospectID: payload.prospectID,
                        Mobile: payload.Mobile,
                        Subscribed: payload.Subscribed
                    }
                };

                API_SERVICE.patch("peoplePortalRestAPI", "/accounts/prospects/propertyalerts", params)
                    .then((res) => {
                        resolve({
                            snackbarSuccess: res.status === "200",
                            showSnackbar: true,
                            data: res.data
                        });
                    })
                    .catch((error) => {
                        resolve({
                            snackbarSuccess: false,
                            showSnackbar: true,
                            error: error.message
                        });
                    });
            });
        },
        async updateFeedback(_, payload) {
            return new Promise((resolve) => {
                const params = {
                    body: {
                        clientName: payload.clientName,
                        prospectID: payload.prospectID,
                        ViewingOID: payload.ViewingOID,
                        PropertyOID: payload.PropertyOID,
                        Feedback: payload.Feedback
                    }
                };
    
                API_SERVICE.patch("peoplePortalRestAPI", "/accounts/prospects/feedback", params)
                    .then((res) => {
                        resolve({
                            snackbarSuccess: res.status === "200",
                            showSnackbar: true,
                            data: res.data
                        });
                    })
                    .catch((error) => {
                        resolve({
                            snackbarSuccess: false,
                            showSnackbar: true,
                            error: error.message
                        });
                    });
            });
        }
    }
};